import { render } from "./DetailInfo.vue?vue&type=template&id=17144699&scoped=true"
import script from "./DetailInfo.vue?vue&type=script&lang=js"
export * from "./DetailInfo.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17144699"]])

export default __exports__